import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateRoleForm from "../../forms/CreateOrUpdateRoleForm";
import { RoleResponseDto } from "../../shared/dtos/role/RoleResponseDto";

interface UpdateRoleModalProps {
  open: boolean;
  onClose: () => void;
  role: RoleResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateRoleModal: React.FC<UpdateRoleModalProps> = ({
  open,
  onClose,
  role,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Update Role: ${role.name}`}
      width="lg"
      loading={loading}
    >
      <CreateOrUpdateRoleForm
        isEditing={true}
        role={role}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default UpdateRoleModal;
